import gql from "graphql-tag";

export const MUTATE_BOOKING = gql`
    mutation mutateBooking($bookingUUID:String!, $currency:String!, $date:String!, $resolveGaps:Boolean, $persist:Boolean!){
        mutateBooking(bookingUUID:$bookingUUID, currency:$currency, date:$date, resolveGaps:$resolveGaps, persist:$persist)
    }
`;